<template>
  <div class="app-container calendar-list-container">
      <avue-crud-table :data="comworkerData" :option="tableoption" :page="page" @size-change="sizeChange" @current-change="currentChange" @row-click="showRow" @search-change="searchChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button class="filter-item filter-item1" size="mini" @click="ygingo" type="primary" icon="el-icon-view"  :disabled = "derail">查看
          </el-button>
          <el-button class="filter-item filter-item1" size="mini" @click="handleStop" type="primary" icon="el-icon-circle-close-outline"  :disabled = "coldderail">冻结
          </el-button>
          <el-button class="filter-item filter-item1" size="mini" @click="handleStart" type="primary" icon="el-icon-circle-check-outline"  :disabled = "nocoldderail">解冻
          </el-button>
           <el-button class="filter-item filter-item1" size="mini" @click="deletestate" type="primary" icon="el-icon-circle-check-outline"  :disabled = "derail">删除
          </el-button>
        </template>
        <template slot-scope="scope" slot="id">
            <el-radio class="radio" v-model="radio"  :label="scope.row.id"></el-radio>
        </template>
      </avue-crud-table>

      <!--企业员工信息对话框-->
      <personnelinfo ref="childinfo" @refresh="refresh"></personnelinfo>
      <workercald ref="childcald" @refresh="refresh"></workercald>
  </div>
</template>
<script>
import {getWorkerInfo} from '@/api/admin/business'
import {getObj,deletepersonnel} from '@/api/admin/workerUser'
import { objKeySort } from '@/util/ajaxsign'
import {personnelall} from '@/const/asset/user'
import personnelinfo from './personnelinfo.vue'
 import workercald from './personnelcald.vue'
 import { dealElement } from '@/util/util'
     import {getImgLink} from '@/config/env'

export default {
components: {personnelinfo,workercald},
  data() {
    return {
      tableoption : personnelall,
      derail : true,
      coldderail : true,
      nocoldderail : true,
      infodetail : {},
      dialogStart:false,
      radio:'',
      comStart:false, //冻结
      comStop:false,  // 解冻
      comWorkerContent:'', //员工详细信息
      dialogVisible:false,  // 信息对话框
      totalStatus:true,    //按钮禁用开关
      // 企业员工数据
      comworkerState:'',
      comworkerData:[],
      comworkerId:'',
      search : {},
      form : {},
      name : '',
      page: {
        pageSizes: [10, 20, 50, 100],
        currentPage: 1,
        total: 0,
        pageSize: 10
      },
    }
  },
  created(){
    this.getworker()
  },
  methods: {
    refresh(){
      this.getworker();
      this.radio = undefined;
      this.derail = true;
      this.coldderail = true;
      this.nocoldderail = true;
    },
    showRow(row){
      this.infodetail = row;
      this.radio = row.id;
      this.name = row.name;
      this.derail =false;
      if(row.status == 1){
        this.nocoldderail = true;
        this.coldderail = false;
      }else if(row.status == 2){
        this.nocoldderail = false;
        this.coldderail = true;
      }

    },
    //获取员工数据
    getworker(){
      //获取企业员工列表
      this.search.current=this.page.currentPage
      this.search.size = this.page.pageSize
      getWorkerInfo(objKeySort(dealElement(this.search))).then(response =>{
            this.comworkerData=response.data.data.rows;
            this.page.total = response.data.data.total;
        })
      },
     //搜索
      searchChange(params){
        this.search = {
          "current" : this.page.currentPage,
          "size" : this.page.pageSize,
          "state" : params.status,
          "conditions" : params.condition
        }
        this.refresh()
      },
      //分页
      sizeChange(val) {
        this.page.pageSize = val
        this.refresh()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.refresh()
      },
      getSerialNumber(index) {
          return index + 1
        },
        handleCurrentChange(val) {
          this.totalStatus=false
          this.comworkerState=val.status
          this.comworkerId=val.id

        },
      // 企业员工信息对话框
      userSee(){
        getObj(objKeySort({userId:this.comworkerId})).then(response =>{
           if(response.data.data.avatar){
             response.data.data.avatar = getImgLink(response.data.data.avatar)
           }else{
             response.data.data.avatar = response.data.data.headimgurl
           }
            this.comWorkerContent =response.data.data
            // 显示冻结 解冻按钮
        })
        this.dialogVisible=true
      },
       //删除
      deletestate(){
        this.$confirm('此操作将永久删除'+this.name+'企业, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              deletepersonnel(objKeySort({userId : this.radio})).then(response => {
                this.refresh()
                this.$message({
                type: 'success',
                message: '删除成功!'
              });
            })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },

      //   冻结
      handleStop(){
        this.$refs.childcald.setsataus(this.radio,"冻结原因");
      },

      // 解冻
      handleStart(){
        this.$refs.childcald.setsataus(this.radio,"解冻原因");
      },
      //查看详情
      ygingo() {
        this.$refs.childinfo.setsataus(this.radio,this.infodetail);
      },

  }
}
</script>
